import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import { IconButton, IconMenu, MenuItem, Avatar } from 'material-ui';
import { reportComment, updatePost } from '../../../stores/newsfeed/actions';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ReportIcon from 'material-ui/svg-icons/content/flag';
import moment from 'moment-timezone';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isEmpty, R.isNil);

class Comment extends Component {
  constructor() {
    super();
    this.state = {
      viewFullPost: false,
    };
  }

  render() {
    const {
      profileImageUrl,
      companyId,
      companyName,
      changeRoute,
      userName,
      timestamp,
      userId,
      ownUserId,
      reportAComment,
      updateAPost,
      postId,
      reported,
      _id,
      comment,
    } = this.props;

    const isLongPost = R.propOr(0, 'length', comment) > 350;

    return (
      <div style={{ padding: '5px 10px' }}>
        <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {
              !isNilOrEmpty(profileImageUrl) ?
                <Avatar
                  backgroundColor="#ffffff"
                  src={profileImageUrl}
                  size={25}
                  onTouchTap={() => changeRoute(`/company/${companyId}`)}
                  style={{ cursor: 'pointer' }}
                /> :
                <Avatar
                  size={25}
                  onTouchTap={() => changeRoute(`/company/${companyId}`)}
                  style={{ cursor: 'pointer' }}
                >{R.head(companyName)}</Avatar>
            }
            <span style={{ marginLeft: '10px', fontSize: '12px' }}>
              {userName}, <a href={`/company/${companyId}`}>{companyName}</a> - {moment(timestamp).from(moment())}
            </span>
          </div>
          <div style={{ marginTop: '5px' }}>
            <IconMenu
              style={{ padding: 0 }}
              iconButtonElement={<IconButton
                style={{ height: '100%', padding: 0, width: '100%' }}
                iconStyle={{ color: '#D3D3D3', padding: 0 }}
                iconClassName="tc-icon-more-vert"
              />}
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
              targetOrigin={{ horizontal: 'left', vertical: 'top' }}
              desktop
            >
              {userId === ownUserId && (<MenuItem
                primaryText="Delete"
                leftIcon={<DeleteIcon color="rgb(255, 64, 129)" />}
                onTouchTap={() => {
                  const confirm = window.confirm('Are you sure you want to delete this comment?');
                  if (confirm) {
                    updateAPost(postId, 'deleteComment', { commentId: _id });
                  }
                }}
              />)}
              {userId !== ownUserId &&
                <MenuItem
                  primaryText={reported || false ? 'Thanks for reporting!' : 'Report Comment'}
                  leftIcon={<ReportIcon color="rgb(255, 64, 129)" />}
                  onTouchTap={() => reportAComment(postId, _id)}
                  disabled={reported || false}
                />}
            </IconMenu>
          </div>
        </div>
        <div style={{ width: '100%', padding: '0 20px 0 35px' }}>
          <div style={{ maxHeight: !this.state.viewFullPost ? '150px' : '', overflowY: !this.state.viewFullPost ? 'hidden' : '', fontSize: '12px', whiteSpace: 'pre-wrap' }}>
            {comment}
          </div>
          {
            isLongPost && !this.state.viewFullPost &&
              <div
                style={{
                  position: 'relative',
                  margin: '15px 10px 0 0',
                  display: 'flex',
                  flexDirection: 'row-reverse',
                }}
                onTouchTap={() => this.setState({ viewFullPost: true })}
              >
                <span style={{ color: '#00bcd4', cursor: 'pointer', fontSize: '12px', bottom: 0, position: 'absolute' }}>
                  <b>+</b> SEE MORE
                </span>
              </div>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ user, newsfeed }) => ({
  ownUserId: user ? user.get('id') : undefined,
  hasMoreComments: newsfeed ? newsfeed.getIn(['postComment', 'hasMoreComments']) : undefined,
});

const mapDispatchToProps = dispatch => ({
  reportAComment: (postId, commentId) => dispatch(reportComment(postId, commentId)),
  updateAPost: (...args) => dispatch(updatePost(...args)),
});

Comment.propTypes = {
  profileImageUrl: PropTypes.string,
  companyId: PropTypes.string,
  companyName: PropTypes.string,
  changeRoute: PropTypes.func,
  userName: PropTypes.string,
  timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  userId: PropTypes.string,
  ownUserId: PropTypes.string,
  reportAComment: PropTypes.func,
  updateAPost: PropTypes.func,
  postId: PropTypes.string,
  reported: PropTypes.bool,
  _id: PropTypes.string,
  comment: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(Comment);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/actionBar/comment.jsx